<ng-container *ngIf="isLoading">
  <section class="loading__overlay"> </section>

  <div class="content">
    <div class="block-wrapper">
      <div class="rotate-block"></div>
    </div>
  </div>
</ng-container>
